module.exports = __webpack_public_path__ + "img/cover_4.5708dbc8.png";